import { render, staticRenderFns } from "./RegistroIngresoTardio.vue?vue&type=template&id=8a482b6e&scoped=true"
import script from "./RegistroIngresoTardio.vue?vue&type=script&lang=ts"
export * from "./RegistroIngresoTardio.vue?vue&type=script&lang=ts"
import style0 from "./RegistroIngresoTardio.vue?vue&type=style&index=0&id=8a482b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a482b6e",
  null
  
)

export default component.exports